<template>
<div>
    <div v-if="!hasProAccess" >
        <v-layout row wrap pb-3>
          <v-flex grow>
            <span class="body-2">Upgrade your account to Pro to activate Customer payments.</span>
            <p class="mt-3">With the Pro plan, allowing your clients the option of being able to pay their invoices online takes minutes. You simply connect with Stripe and you’re good to go. As soon as the invoice has been paid online, you’ll receive a notification.
</p>
            <v-btn class="v-btn--medium mb-3" depressed small color="primary" to="/settings/billing" >Upgrade my account</v-btn>
          </v-flex>
        </v-layout>
    </div>
    <div v-else>
      <v-layout align-start row fill-height wrap
      v-if="group.stripeConnect !== null && group.stripeConnect !== undefined">
        <v-flex xs12 md6>
          <p class="primary--text body-2">Payments are now enabled and your customers can pay their invoices online. </p>
          <p class="caption mb-0">Do you want payments enabled by default on new invoices?</p>
          <v-switch
          :label='onlinePaymentsOn ? "Yes" : "No"'
          color="primary"
          v-model="onlinePaymentsOn"
          ></v-switch>
          <p class="caption mb-0">NB: You can also enable or disable customer payments for each invoice using the 'Take online payments' switch on the invoice page.  </p>
        </v-flex>
        <v-flex xs12 md5 offset-md1 >
          <img class="stripe" src="/img/stripe-logo.png" alt="stripe" />
        </v-flex>
      </v-layout>
      <v-layout align-start row fill-height wrap
      v-else>
        <v-flex xs12 md6>
          <p >Connect your Worktabs account with <a href="https://stripe.com" target="_blank">Stripe</a> to allow customers to pay their invoices online using a credit or debit card.
          </p>
          <v-btn
          :href="`https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${stripe_connect_key}&scope=read_write&state=${stripeState}&stripe_user[email]=${group.email}&redirect_uri=${stripeRedirectURL}`"
          depressed
          karge
          color="primary"
          target="_blank"
          class="">
          Connect to Stripe
        </v-btn>
      </v-flex>
      <v-flex xs12 md5 offset-md1 pb-3 text-xs-center justify-center :class="{'pt-4' : $vuetify.breakpoint.xsOnly, 'pt-0' : !$vuetify.breakpoint.xsOnly}">
        <img class="stripe" src="/img/stripe-logo.png" alt="Stripe logo" />
      </v-flex>
    </v-layout>
  </div>
</div>
</template>

<script>
export default {
  name: 'CustomerPayments',
  props: {
    invoiceId: {
      type: String
    }
  },
  data () {
    return {
      user: this.$store.getters.user,
      site_uri: process.env.VUE_APP_SITEURI,
      stripe_connect_key: process.env.VUE_APP_STRIPECONNECTKEY,
      group: this.$store.getters.group
    }
  },
  computed: {
    onlinePaymentsOn: {
      set (onlinePaymentsOn) {
        this.$store.dispatch('updateGroupSettings', {
          ...this.group,
          onlinePaymentsOn
        })
        this.$emit('online-payments-change', onlinePaymentsOn)
      },
      get () {
        return this.$store.getters.group.onlinePaymentsOn
      }
    },
    stripeState () {
      let stripeState = ''
      if (this.invoiceId !== '' && this.invoiceId !== undefined) {
        stripeState = `${this.user.group}invoice${this.invoiceId}`
      } else {
        stripeState = this.user.group
      }
      return stripeState
    },
    stripeRedirectURL () {
      if (location.hostname === 'localhost') {
        return 'https://41af-2a00-23c8-8110-4201-a934-1d8e-dd0f-df5c.ngrok.io/projectsapp-dev/us-central1/authStripeConnect'
      } else {
        return `${this.site_uri}/authStripeConnect`
      }
    },
    hasProAccess () {
      return this.$store.getters.hasProAccess
    }
  }
}
</script>
<style scoped>
.stripe{
  max-width:100%;
  margin-bottom:20px;
}

</style>
